// ===== MASCUSTOM THEME JS =====

document.addEventListener('DOMContentLoaded', function() {

  // NAV SCROLL
  const navbar = document.getElementById('navbar');
  if (navbar) {
    window.addEventListener('scroll', function() {
      navbar.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  // MOBILE MENU
  const menuBtn = document.getElementById('menuBtn');
  const menuClose = document.getElementById('menuClose');
  const mobileMenu = document.getElementById('mobileMenu');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function() { mobileMenu.classList.add('open'); });
    menuClose.addEventListener('click', function() { mobileMenu.classList.remove('open'); });
    document.querySelectorAll('.mobile-link, .mobile-sublink').forEach(function(l) {
      l.addEventListener('click', function() { mobileMenu.classList.remove('open'); });
    });
  }

  // MOBILE ACCORDION
  document.querySelectorAll('.mobile-menu-toggle').forEach(function(toggle) {
    toggle.addEventListener('click', function() {
      var group = this.closest('.mobile-menu-group');
      var wasOpen = group.classList.contains('open');
      document.querySelectorAll('.mobile-menu-group').forEach(function(g) { g.classList.remove('open'); });
      if (!wasOpen) group.classList.add('open');
    });
  });

  // SEARCH DRAWER
  const searchToggle = document.querySelector('.search-toggle');
  const searchDrawer = document.getElementById('searchDrawer');
  const searchClose = document.getElementById('searchClose');
  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', function() { searchDrawer.classList.add('open'); });
    searchClose.addEventListener('click', function() { searchDrawer.classList.remove('open'); });
    searchDrawer.addEventListener('click', function(e) {
      if (e.target === searchDrawer) searchDrawer.classList.remove('open');
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') searchDrawer.classList.remove('open');
    });
  }

  // SCROLL REVEAL
  const revealElements = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealElements.length) {
    const revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          revealObserver.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    revealElements.forEach(function(el) { revealObserver.observe(el); });
  } else {
    revealElements.forEach(function(el) { el.classList.add('visible'); });
  }

  // SMOOTH SCROLL
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var id = this.getAttribute('href');
      if (id === '#') return;
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.pageYOffset - 70,
          behavior: 'smooth'
        });
      }
    });
  });

  // CARD CLICK -> SCROLL TO CONTACT (for marketing cards)
  document.querySelectorAll('.solution-card, .sol-item, .type-card, .style-card, .feature-card').forEach(function(card) {
    card.addEventListener('click', function() {
      var contact = document.getElementById('contact');
      if (contact) {
        window.scrollTo({
          top: contact.getBoundingClientRect().top + window.pageYOffset - 70,
          behavior: 'smooth'
        });
      }
    });
  });

  // FEATURED SLIDER DOTS
  var dots = document.querySelectorAll('.feature-dots span');
  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() {
      dots.forEach(function(d) { d.classList.remove('active'); });
      dot.classList.add('active');
    });
  });

});
